
<script>
import New from './New9'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
